import { useEffect } from "react";
import Dispatcher from "../flux/Dispatcher";
import ActionTypes from "../flux/ActionTypes";
import PageLoadingOverlay from "../components/PageLoadingOverlay";
import useResponsive from "../hooks/useResponsive";
import __ from '../utils/translator';
import postMessageToParent from "../utils/postMessageToParent";
import { Redirect } from "react-router-dom";
import AuthenticationManager from "../flux/AuthenticationManager";

export default function LoginCallback() {
  const { isMobile } = useResponsive();

  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');

  useEffect(() => {
    if (code === null) {
      return;
    }

    if (
      window.localStorage.getItem('enrolled-in-biometric-auth') === null &&
      isMobile
    ) {
      postMessageToParent('pre-authenticate');
    }
  }, [code]);

  useEffect(() => {
    if (code === null) {
      return;
    }

    AuthenticationManager.authenticate(code)
      .then(resolved => console.log(resolved));
  }, [code]);

  if (code === null) {
    alert("An unknown error occurred while authenticating.")

    return (
      <Redirect to="/login" />
    )
  }

  return (
    <PageLoadingOverlay visible />
  );
}
